module.exports = __webpack_public_path__ + "img/green-cer.ec7f9573.webp";